<template>
<div
  v-if="userData"
  class="block-user_bus"
  :class="{ [curTheme]: true }">

  <button
    v-if="userData.Transient.Permissions.USER_BLOCK && !userData.Transient.IsBlocked"
    @click="winOn = true"
    class="upd_control-btn lite-button sm-button">Блокировать</button>
  <button
    v-if="userData.Transient.Permissions.USER_UNBLOCK && userData.Transient.IsBlocked"
    @click="unblockUser"
    class="upd_control-btn lite-button sm-button">Разблокировать</button>

  <el-dialog
    class="bus_win"
    title="Блокировать пользователя"
    :visible.sync="winOn">
    <el-input
      type="textarea"
      :autosize="{ minRows: 2, maxRows: 20 }"
      placeholder="Укажите причину блокировки..."
      v-model="msg"/>
    <div slot="footer" class="dialog-footer buttons-wrap">
      <button
        class="dialog-primary-btn"
        @click="blockUser">
        Блокировать пользователя
      </button>
      <button
        class="dialog-empty-btn"
        @click="winOn = false">
        Закрыть окно
      </button>
    </div>
  </el-dialog>

</div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';

export default {

  props: {
    userData: Object,
    userId: String,
  },

  data() {
    return {
      msg: '',
      winOn: false,
    };
  },

  methods: {

    blockUser() {
      this.winOn = false;
      Vue.$loading.on();
      axios.put(`users/${this.userId}/block`, null, { params: { cause: this.msg } }).then(() => {
        this.$emit('on-user-blocked');
        this.$message.success('Пользователь заблокирован.');
      }).catch(() => {
        this.$notify.error('Ошибка при блокировке пользователя.');
      }).finally(() => Vue.$loading.off());
    },

    unblockUser() {
      Vue.$loading.on();
      axios.put(`users/${this.userId}/unblock`).then(() => {
        this.$emit('on-user-unblocked');
        this.$message.success('Пользователь разблокирован.');
      }).catch(() => {
        this.$notify.error('Ошибка при разблокировке пользователя.');
      }).finally(() => Vue.$loading.off());
    },

  },

};
</script>

<style lang="scss">
@import "../styles/common/main";

.block-user_bus {
  .el-dialog {
    max-width: 800px;
  }
  .bus_label {
    margin-bottom: 10px;
    font-weight: 400;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BlockUser.vue